export default function(el, offset) {
  if ( offset === undefined )
    offset = 60

  let bounding = el.getBoundingClientRect()
  let scrollBy = bounding.top - offset

  window.scrollBy({ top: scrollBy, behavior: 'smooth' });
}
